import React from 'react';
import Image from 'next/image';
import { 
  FaWrench, 
  FaQuestion 
} from 'react-icons/fa';

interface IconProps {
  size?: 'small' | 'medium' | 'large';
}

const getIconSize = (size?: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small': return 32; // 32px
    case 'large': return 80; // 80px
    case 'medium':
    default: return 56; // 56px
  }
};

const getIconSizeClass = (size?: 'small' | 'medium' | 'large') => {
  switch (size) {
    case 'small': return 'text-2xl'; // ~24px
    case 'large': return 'text-6xl'; // ~64px
    case 'medium':
    default: return 'text-4xl'; // ~40px
  }
};

export const ToiletIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-toilette.jpeg" 
        alt="Toilette" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const ShowerIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-douche.jpeg" 
        alt="Douche" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const BathtubIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-baignoire.jpeg" 
        alt="Baignoire" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const SinkIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-evier.jpeg" 
        alt="Évier" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const LavaboIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-lavabo.png" 
        alt="Lavabo" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const WaterHeaterIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-ballon.jpeg" 
        alt="Ballon d'eau chaude" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const HeatingIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-chauffage.jpeg" 
        alt="Chauffage" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const LeakIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-sanibroyeur.jpeg" 
        alt="Sanibroyeur" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const ToolsIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-repa.jpeg" 
        alt="Réparation" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

export const OtherIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-autre.jpeg" 
        alt="Autre" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
};

// Nouvelles icônes pour les types de service
export const InstallationIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-insta.jpeg" 
        alt="Installation" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
        priority
      />
    </div>
  );
};

export const ReparationIcon: React.FC<IconProps> = ({ size }) => {
  const iconSize = getIconSize(size);
  return (
    <div className="flex justify-center items-center" style={{ width: iconSize, height: iconSize }}>
      <Image 
        src="/icon-repa.jpeg" 
        alt="Réparation" 
        width={iconSize} 
        height={iconSize}
        className="object-contain rounded-lg"
      />
    </div>
  );
}; 